import { getMessage } from '@tcc/i18n';
import { Button, ButtonFill, ComponentColor, DialogContent, DialogFooter, Typography, TypographyVariant } from '@tcc/fds';
import type { BaseFieldRegionReportModalParams } from '../types/modals';
import { RegionReportModal } from '../RegionReportModal';

export interface DeleteConfirmationViewProps extends BaseFieldRegionReportModalParams {
  onDeleteCancelConfirm: () => void;
  onDeleteCancelGoBack: () => void;
}

export const DeleteConfirmationView = ({
  onDeleteCancelConfirm,
  onDeleteCancelGoBack,
  dialogTestId,
  onOpenChange
}: DeleteConfirmationViewProps) => (
  <RegionReportModal
    dialogTestId={dialogTestId}
    modalViewKey='dmb-region-report-delete-confirmation-modal'
    onOpenChange={onOpenChange}>
    <DialogContent testId='dmb-region-report-delete-confirmation-modal'>
      <Typography variant={TypographyVariant.Heading}>
        {getMessage('regions.report.modal.confirm.delete')}
      </Typography>
    </DialogContent>
    <DialogFooter>
       <Button
        testId='confirmation-modal-go-back-button'
        onClick={onDeleteCancelGoBack}
        fill={ButtonFill.Outline}
        color={ComponentColor.Primary}>
          {getMessage('confirmationModal.goBack')}
      </Button>
      <Button
        testId='confirmation-modal-confirm-button'
        onClick={onDeleteCancelConfirm}
        fill={ButtonFill.Solid}
        color={ComponentColor.Error}>
          {getMessage('regions.report.modal.delete')}
      </Button>
    </DialogFooter>
  </RegionReportModal>
);
